var _path, _g, _path2, _path3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulltIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 12,
    viewBox: "0 0 56 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6L12 6",
    stroke: "#8098F9",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "2 1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6201_21079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00033 4.66671C4.73671 4.66671 5.33366 5.26366 5.33366 6.00004C5.33366 6.73642 4.73671 7.33337 4.00033 7.33337C3.26395 7.33337 2.66699 6.73642 2.66699 6.00004C2.66699 5.26366 3.26395 4.66671 4.00033 4.66671Z",
    fill: "#6172F3",
    stroke: "#6172F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6L44 6",
    stroke: "#8098F9",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "2 1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 6L44 6",
    stroke: "#8098F9",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "2 1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6201_21079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9997 4.66671C51.2633 4.66671 50.6663 5.26366 50.6663 6.00004C50.6663 6.73642 51.2633 7.33337 51.9997 7.33337C52.7361 7.33337 53.333 6.73642 53.333 6.00004C53.333 5.26366 52.7361 4.66671 51.9997 4.66671Z",
    fill: "#6172F3",
    stroke: "#6172F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6201_21079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6201_21079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "matrix(0 -1 -1 0 56 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulltIcon);
export default __webpack_public_path__ + "static/media/bullt_icon.06a0467211bbb7dc84da9378e1d21a17.svg";
export { ForwardRef as ReactComponent };